import React from 'react'
import { ColumnInput, ColumnLabel, ColumnsContainer, MinAndMaxContainer } from './style'
import { useOutletContext } from 'react-router-dom'
import { CertificateOutletType } from '../..'

const StructureColumns:React.FC<{structureIndex:number}> = ({structureIndex}) => {
  const { param, setParam } = useOutletContext<CertificateOutletType>()
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, columnIndex: number, minOrMax: 'min' | 'max') => {
    setParam(prev => ({
      ...prev,
      structures: prev.structures.map((structure, sIndex) => (
        sIndex === structureIndex 
        ? { ...structure, columns: structure.columns.map((column, cIndex) => (
          cIndex === columnIndex
          ? {...column, [minOrMax]: e.target.value}
          : column
        ))} 
        : structure
      ))
    }))
  }
  
  return (
    <ColumnsContainer quantityGrid={param.structures[structureIndex].columns.length}>
      {param.structures[structureIndex].columns.map((column, index) => 
        <ColumnLabel 
          isItLast={index === param.structures[structureIndex].columns.length - 1}
          key={index}
        > {column.name} ({column.unitUsed?.name})</ColumnLabel>
      )}
      {param.structures[structureIndex].columns.map((column, index) => 
        <MinAndMaxContainer key={index}>
          <ColumnInput
            placeholder='min'
            position={index === 0 ? 'first' : undefined}
            value={column.min || ''}
            onChange={e => handleChange(e, index, 'min')}
          />
          <ColumnInput
            placeholder='max'
            position={index === param.structures[structureIndex].columns.length - 1 ? 'last' : undefined}
            value={column.max || ''}
            onChange={e => handleChange(e, index, 'max')}
          />
        </MinAndMaxContainer>
      )}
    </ColumnsContainer>
  )
}

export default StructureColumns